export default "__VITE_ASSET__CrmWZoVx__"